import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class MasterApprovalFilter extends Component {
    statusOptions = [
        {
            label: "ACTIVE",
            value: "ACTIVE",
        },
        {
            label: "INACTIVE",
            value: "INACTIVE",
        },
    ];

    levelOptions = [
        {
            label: "0",
            value: 0,
        },
        {
            label: "1",
            value: 1,
        },
        {
            label: "2",
            value: 2,
        },
        {
            label: "3",
            value: 3,
        },
        {
            label: "4",
            value: 4,
        },
        {
            label: "5",
            value: 5,
        },
        {
            label: "6",
            value: 6,
        },
        {
            label: "7",
            value: 7,
        },
        {
            label: "8",
            value: 8,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            dataLocator: [],
        };
    }

    componentDidMount() {

    }

    handleSubmit = () => {
        this.props.onSubmit();
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_approvalId"
                            name="approvalid"
                            label="ID Pelanggaran"
                            value={this.props.selectedData.approvalid}
                            onChange={({target}) =>
                                this.props.onValueChange(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_description"
                            name="approvaldescription"
                            label="Deksripsi Pelanggaran"
                            value={this.props.selectedData.approvaldescription}
                            onChange={({target}) =>
                                this.props.onValueChange(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="input_text_ahas_line"
                            name="approvalahassline"
                            label="AhassLine"
                            box="search"
                            isClearable
                            options={this.levelOptions}
                            value={this.props.selectedData.approvalahassline}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <SimpleDDL
                            id="input_text_mkt_line"
                            name="approvalmarketingline"
                            label="MktLine"
                            box="search"
                            isClearable
                            options={this.levelOptions}
                            value={this.props.selectedData.approvalmarketingline}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <SimpleDDL
                            id="input_text_adm_line"
                            name="approvaladminline"
                            label="AdmLine"
                            box="search"
                            isClearable
                            options={this.levelOptions}
                            value={this.props.selectedData.approvaladminline}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <SimpleDDL
                            id="input_text_status"
                            name="status"
                            box="search"
                            label="Status"
                            isClearable
                            options={this.statusOptions}
                            value={this.props.selectedData.status}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <div style={{textAlign: "right"}}>
                            <SimpleButton
                                type="button"
                                secondary
                                onClick={() => this.props.onClearFilter()}
                            >
                                Hapus
                            </SimpleButton>
                            <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                        </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterApprovalFilter;